import React, { useEffect } from 'react'
import styled from 'styled-components'

const Container = styled.div`
.description_title {
    font-family: 'SF UI Text', sans-serif;
    font-weight: 400;
    font-size: 2.75rem;
    line-height: 160%;
    margin: 3rem 0;
}
.description_text {
    font-family: 'SF UI Text', sans-serif;
    font-weight: 300;
    font-size: 2.5rem;
    line-height: 150%;
}

`

export const ProductDescription = ({ description, title, id }) => {

    useEffect(() => {
        document.getElementById(id).innerHTML = description

    })

    return (
        <Container className="description">
            <p className="description_title" > {title} </p>
            <div className="description_text" id={id}></div>
        </Container>
    )

}